import React from 'react'
import Accessories from './Components/Accessories'

const AccessoriesPage = () => {
  return (
    <div>
      <Accessories />
    </div>
  )
}

export default AccessoriesPage